module.exports = __webpack_public_path__ + "3bf919e7b1939b275adaa5fd2d86e740.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/document.svg
// module id = 97
// module chunks = 0